<template>
  <div class="review-module-container">
    <div class="zhanwei4"></div>

    <!-- 顶部全局复盘卡片（已保留恢复） -->
    <div class="global-video-card">
      <div class="card-left">
        <div class="badge-icon">
          <el-icon><VideoCamera /></el-icon>
        </div>
        <div class="text-group">
          <span class="card-title">全局复盘视频</span>
          <span class="card-sub">配置游戏通关后总览视频的嵌入式播放地址</span>
        </div>
      </div>
      <div class="card-right">
        <el-input
          v-model="globalReviewLink"
          placeholder="请输入视频链接 (例如: https://...)"
          clearable
          class="global-input"
        />
        <el-button
          type="primary"
          class="global-save-btn"
          @click="saveReviewLink"
        >
          保存全局视频
        </el-button>
      </div>
    </div>

    <!-- 关卡切换分段控制器 -->
    <div class="select-bar-wrapper">
      <el-segmented
        v-model="levelValue"
        :options="levelsOptions"
        block
        @change="changeOption"
        size="large"
        class="selectBar"
      />
    </div>

    <!-- 主表单与预览视口 -->
    <div class="form-container">
      <div class="panel">
        <!-- 左侧编辑表单 -->
        <div class="panel_left">
          <el-form
            :model="form"
            label-width="auto"
            label-position="top"
            ref="ruleForm"
            status-icon
            class="clean-form"
          >
            <el-form-item label="关卡复盘标题">
              <el-input
                v-model="form.reviewTitle"
                placeholder="例如：本关核心推理逻辑与背景复盘"
                clearable
              />
            </el-form-item>

            <el-form-item label="复盘正文内容">
              <el-input
                v-model="form.reviewContent"
                type="textarea"
                placeholder="详细复盘本关涉及的剧情暗线、解题思路与通关线索..."
                :rows="8"
                maxlength="500"
                show-word-limit
              />
            </el-form-item>

            <!-- 复盘配图上传（关卡内部单视频已隐藏，仅图文） -->
            <el-form-item label="复盘配图">
              <div class="single-uploader-card">
                <el-upload
                  class="uploader-box"
                  :action="UpdateApi"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :disabled="allowUpload"
                >
                  <div v-if="form.reviewImg" class="img-preview-box">
                    <el-image
                      :src="form.reviewImg"
                      class="img-content"
                      fit="contain"
                    />
                    <div class="hover-mask">
                      <span
                        class="del-btn"
                        @click.stop="clearImage"
                        title="删除图片"
                      >
                        <el-icon><Delete /></el-icon>
                      </span>
                    </div>
                  </div>
                  <div v-else class="upload-trigger">
                    <el-icon class="icon"><Plus /></el-icon>
                    <span class="text">上传复盘附图</span>
                    <span class="sub-text"
                      >支持 4:3 | 1:1 | 3:4 / 小于 5MB</span
                    >
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>

          <div class="action-bar">
            <el-button
              type="primary"
              class="save-btn"
              size="large"
              @click="saveSettings"
            >
              保存当前关卡复盘
            </el-button>
          </div>
        </div>

        <!-- 右侧拟物化手机视口 -->
        <div class="panel_right">
          <div class="preview-header">
            <span class="badge-dot"></span>
            <span>移动端复盘呈现</span>
          </div>

          <div class="mockup-phone">
            <!-- 灵动岛/刘海 -->
            <div class="phone-top-bar">
              <div class="notch"></div>
            </div>

            <div class="phone-screen">
              <!-- 顶部导航 -->
              <div class="mock-nav">
                <el-icon><ArrowLeft /></el-icon>
                <span class="nav-title">关卡复盘</span>
                <span class="nav-placeholder"></span>
              </div>

              <!-- 顶部图片视口（仅纯图文展示） -->
              <div class="screen-media">
                <el-image
                  v-if="form.reviewImg"
                  :src="form.reviewImg"
                  alt="复盘配图"
                  class="preview-img"
                  fit="contain"
                />
                <div v-else class="media-placeholder">
                  <el-icon class="ph-icon"><PictureFilled /></el-icon>
                  <span>暂无复盘配图</span>
                </div>
              </div>

              <!-- 正文内容区 -->
              <div class="screen-body">
                <h3 class="screen-title">
                  {{ form.reviewTitle || "复盘标题占位" }}
                </h3>
                <div class="screen-desc">
                  {{
                    form.reviewContent ||
                    "关卡解析、真相还原或复盘要点内容将在此处展示，支持自动断行与上下平滑滑动..."
                  }}
                </div>
              </div>

              <!-- 底部操作按钮 -->
              <div class="screen-footer">
                <button class="mock-next-btn">已完成复盘，继续</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="zhanwei4"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {
  Plus,
  VideoCamera,
  PictureFilled,
  Delete,
  ArrowLeft,
} from "@element-plus/icons-vue";
import { ElMessage, ElNotification } from "element-plus";

export default defineComponent({
  name: "GameReviewModule",
  components: {
    Plus,
    VideoCamera,
    PictureFilled,
    Delete,
    ArrowLeft,
  },
  props: ["dataForm"],
  data(): any {
    return {
      globalReviewLink: "",
      form: {
        reviewTitle: "",
        reviewImg: "",
        reviewContent: "",
      },
      fileList: [],
      levelValue: "",
      game: null,
    };
  },
  computed: {
    allowUpload(): boolean {
      return Boolean(this.form.reviewImg);
    },
    UpdateApi(): string {
      return process.env.VUE_APP_Update_API || "";
    },
    levelsOptions(): string[] {
      const levels = this.$store.state.game.levels;
      return Array.isArray(levels) ? levels.map((item: any) => item.name) : [];
    },
  },
  watch: {
    levelsOptions: {
      immediate: true,
      handler(newOptions) {
        if (newOptions && newOptions.length > 0) {
          if (!this.levelValue || !newOptions.includes(this.levelValue)) {
            this.levelValue = newOptions[0];
            this.changeOption(this.levelValue);
          }
        }
      },
    },
    dataForm: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.updateForm(newVal);
        }
      },
    },
  },
  mounted() {
    const gameId = this.$route.params.id;
    if (gameId && gameId !== "0") {
      const game = this.$store.state.game.games.find(
        (item: any) => item.id == gameId
      );
      if (game) {
        this.game = game;
        this.globalReviewLink = game.globalReviewLink || "";
      }
    }
  },
  methods: {
    updateForm(dataForm: any) {
      this.form.reviewTitle = dataForm.reviewTitle || "";
      this.form.reviewImg = dataForm.reviewImg || "";
      this.form.reviewContent = dataForm.reviewContent || "";
    },
    beforeAvatarUpload(file: File): boolean {
      const isAllowed =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/webp";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isAllowed) {
        ElNotification.warning({
          message: "请上传 PNG/JPG/WEBP 格式图片",
          offset: 100,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片大小不可超过 2MB",
          offset: 100,
        });
        return false;
      }
      return true;
    },
    handleAvatarSuccess(response: any) {
      if (response?.data?.returnFileUrl) {
        this.form.reviewImg = response.data.returnFileUrl;
      }
    },

    async clearImage() {
      const fileName = this.form.reviewImg;

      if (!fileName) return;

      try {
        // 1. 匹配 action 参数签名（传对象）
        const delFinished = await this.$store.dispatch("user/delFile", {
          fileName,
        });

        // 2. 只有删除成功后才清空前端字段
        if (delFinished === 1) {
          this.form.reviewImg = "";
        }
      } catch (error) {
        console.error("清除图片失败:", error);
      }
    },
    saveSettings() {
      const level = this.$store.state.game.levels.find(
        (item: any) => item.name === this.levelValue
      );

      if (!level) {
        ElMessage.error("未找到对应关卡数据");
        return;
      }

      this.$store
        .dispatch("game/editGameReview", {
          gameLevelId: level.levelId,
          reviewTitle: this.form.reviewTitle || "",
          reviewContent: this.form.reviewContent || "",
          reviewLink: null, // 关卡单视频功能隐藏，置空
          reviewImg: this.form.reviewImg || "",
        })
        .then(() => {
          ElMessage.success(`${this.levelValue} 复盘配置已保存`);
        })
        .catch((err: any) => {
          console.error(err);
          ElMessage.error("保存失败，请重试");
        });
    },
    changeOption(val: string) {
      const level = this.$store.state.game.levels.find(
        (item: any) => item.name === val
      );
      if (!level) return;

      this.$store
        .dispatch("game/getLevelDetail", { levelId: level.levelId })
        .then((res: any) => {
          if (res?.levelInfo) {
            this.form = {
              reviewTitle: res.levelInfo.reviewTitle || "",
              reviewImg: res.levelInfo.reviewImg || "",
              reviewContent: res.levelInfo.reviewContent || "",
            };
          }
        })
        .catch((err: any) => {
          console.error(err);
        });
    },
    saveReviewLink() {
      if (!this.game) {
        ElMessage.warning("游戏数据尚未加载完成");
        return;
      }

      this.game.globalReviewLink = this.globalReviewLink;
      const { updateTime, ...formWithoutUpdateTime } = this.game;
      const payload = { ...formWithoutUpdateTime };

      if (payload.tips && typeof payload.tips !== "string") {
        payload.tips = JSON.stringify(payload.tips);
      }
      if (Array.isArray(payload.region)) {
        payload.region = payload.region.join(",");
      }

      this.$store
        .dispatch("game/updateGame", { gameBean: payload })
        .then(() => {
          ElMessage.success("全局复盘视频链接已更新");
        })
        .catch(() => {
          ElMessage.error("保存失败");
        });
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;

.zhanwei4 {
  height: 20px;
}

.review-module-container {
  width: 100%;
}

// 顶部全局复盘卡片
.global-video-card {
  max-width: 1200px;
  margin: 0 auto 20px;
  padding: 16px 24px;
  background: #ffffff;
  border: 1px solid @card-border;
  border-radius: 14px;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.03);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  box-sizing: border-box;

  .card-left {
    display: flex;
    align-items: center;
    gap: 14px;

    .badge-icon {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      background: @primary-light;
      color: @primary-color;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      flex-shrink: 0;
    }

    .text-group {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .card-title {
        font-size: 15px;
        font-weight: 700;
        color: @text-main;
      }

      .card-sub {
        font-size: 12px;
        color: @text-muted;
      }
    }
  }

  .card-right {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    max-width: 500px;

    .global-input {
      :deep(.el-input__wrapper) {
        border-radius: 8px;
        box-shadow: 0 0 0 1px @border-color inset;

        &:hover {
          box-shadow: 0 0 0 1px #cbd5e1 inset;
        }

        &.is-focus {
          box-shadow: 0 0 0 1px @primary-color inset !important;
        }
      }
    }

    .global-save-btn {
      height: 40px;
      padding: 0 20px;
      border-radius: 8px;
      font-weight: 600;
      background-color: @primary-color;
      border-color: @primary-color;
      flex-shrink: 0;
      box-shadow: 0 3px 10px rgba(93, 95, 239, 0.25);
      transition: all 0.2s ease;

      &:hover {
        background-color: #4b4de0;
        border-color: #4b4de0;
        transform: translateY(-1px);
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;

    .card-right {
      max-width: 100%;
    }
  }
}

// 关卡分段选择条
.select-bar-wrapper {
  max-width: 1200px;
  margin: 0 auto 24px;
  box-sizing: border-box;

  .selectBar {
    padding: 4px;
    background-color: #f1f5f9;
    border-radius: 10px;
    border: 1px solid @border-color;

    :deep(.el-segmented__item) {
      border-radius: 8px;
      font-size: 14px;
      font-weight: 600;
      color: @text-sub;
      padding: 8px 0;
      transition: all 0.25s ease;

      //&:hover {
      //  color: @primary-color;
      //}

      &.is-selected {
        background-color: #ffffff;
        color: #ffffff;
        box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
      }
    }
  }
}

// 主体展示容器
.form-container {
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.panel {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  background: #ffffff;
  padding: 32px;
  border-radius: 16px;
  border: 1px solid @card-border;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;

  &_left {
    flex: 1;
    max-width: 600px;

    .clean-form {
      :deep(.el-form-item) {
        margin-bottom: 22px;

        .el-form-item__label {
          font-size: 13.5px;
          font-weight: 600;
          color: @text-main;
          padding-bottom: 6px;
        }
      }

      :deep(.el-input__wrapper),
      :deep(.el-textarea__inner) {
        border-radius: 8px;
        box-shadow: 0 0 0 1px @border-color inset;
        transition: all 0.2s ease;

        &:hover {
          box-shadow: 0 0 0 1px #cbd5e1 inset;
        }

        &.is-focus,
        &:focus {
          box-shadow: 0 0 0 1px @primary-color inset !important;
        }
      }
    }

    // 单图卡片上传器
    .single-uploader-card {
      .uploader-box {
        :deep(.el-upload) {
          width: 100%;
          display: block;
          cursor: pointer;
        }
      }

      .img-preview-box {
        position: relative;
        width: 100%;
        height: 170px;
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid @border-color;
        background: #f8fafc;

        .img-content {
          width: 100%;
          height: 100%;
          display: block;
        }

        .hover-mask {
          position: absolute;
          inset: 0;
          background: rgba(15, 23, 42, 0.55);
          backdrop-filter: blur(2px);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.25s ease;

          .del-btn {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            background: #ffffff;
            color: @danger-color;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.12);
            }
          }
        }

        &:hover .hover-mask {
          opacity: 1;
        }
      }

      .upload-trigger {
        width: 100%;
        height: 130px;
        border: 1.5px dashed #cbd5e1;
        border-radius: 10px;
        background: #f8fafc;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 6px;
        transition: all 0.25s ease;

        .icon {
          font-size: 20px;
          color: @text-sub;
        }

        .text {
          font-size: 13.5px;
          font-weight: 600;
          color: @text-main;
        }

        .sub-text {
          font-size: 11.5px;
          color: @text-muted;
        }

        &:hover {
          border-color: @primary-color;
          background: @primary-light;

          .icon,
          .text {
            color: @primary-color;
          }
        }
      }
    }

    .action-bar {
      margin-top: 32px;
      border-top: 1px solid @border-color;
      padding-top: 20px;

      .save-btn {
        width: 100%;
        height: 42px;
        border-radius: 8px;
        background-color: @primary-color;
        border-color: @primary-color;
        font-weight: 600;
        box-shadow: 0 4px 12px rgba(93, 95, 239, 0.25);
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          background-color: #4b4de0;
          border-color: #4b4de0;
          transform: translateY(-1px);
          box-shadow: 0 6px 16px rgba(93, 95, 239, 0.35);
        }
      }
    }
  }

  // 右侧真机拟物视口
  &_right {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;

    .preview-header {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      font-weight: 600;
      color: @text-sub;
      margin-bottom: 14px;

      .badge-dot {
        width: 8px;
        height: 8px;
        background: #10b981;
        border-radius: 50%;
        box-shadow: 0 0 6px rgba(16, 185, 129, 0.6);
      }
    }

    .mockup-phone {
      width: 290px;
      height: 540px;
      background: #ffffff;
      border-radius: 36px;
      border: 10px solid #0f172a;
      box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.16);
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .phone-top-bar {
        width: 100%;
        height: 20px;
        display: flex;
        justify-content: center;
        background: #ffffff;
        z-index: 10;

        .notch {
          width: 76px;
          height: 12px;
          background: #0f172a;
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }

      .phone-screen {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        background: #f8fafc;
      }

      .mock-nav {
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 14px;
        border-bottom: 1px solid @border-color;
        background: #ffffff;
        font-size: 13px;
        color: @text-main;

        .nav-title {
          font-weight: 700;
        }

        .nav-placeholder {
          width: 16px;
        }
      }

      .screen-media {
        width: 100%;
        height: 170px;
        background: #e2e8f0;
        overflow: hidden;
        flex-shrink: 0;

        .preview-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .media-placeholder {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 6px;
          color: @text-muted;
          font-size: 11px;

          .ph-icon {
            font-size: 24px;
          }
        }
      }

      .screen-body {
        flex: 1;
        padding: 14px 16px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        .screen-title {
          font-size: 15px;
          font-weight: 700;
          color: @text-main;
          margin: 0 0 8px 0;
          line-height: 1.4;
        }

        .screen-desc {
          font-size: 12.5px;
          color: @text-sub;
          line-height: 1.65;
          white-space: pre-wrap;
          word-break: break-all;
        }
      }

      .screen-footer {
        padding: 10px 16px 14px;
        background: #ffffff;
        border-top: 1px solid @border-color;

        .mock-next-btn {
          width: 100%;
          height: 36px;
          border-radius: 18px;
          border: none;
          background: @primary-color;
          color: #ffffff;
          font-size: 13px;
          font-weight: 600;
          cursor: default;
          box-shadow: 0 3px 8px rgba(93, 95, 239, 0.3);
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .panel {
    flex-direction: column;
    align-items: center;

    &_left {
      max-width: 100%;
    }
  }
}
</style>
